import {callCustomMethodAsync} from '../service/ApiService';

let moduleApi = {};
let moduleName = "dda_codes";


moduleApi.getLastestCode = async (id) => {
  let api = {
    module: moduleName,
    body: {
      dda_category_id: id
    },
    type: "get_lastest_code",
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

export default moduleApi;
